/*
 * Copyright 2025 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package repository


// Singleton instance for Web
private var singletonAdviceRepository: WebAdviceCardRepository? = null

/**
 * Web/JS factory function for creating WebAdviceCardRepository
 * Returns a singleton to avoid multiple database connections
 * Seeds default cards on first access
 * Uses WebAdviceCardRepository which is optimized for async WebWorkerDriver
 */
suspend fun createAdviceCardRepositoryAsync(): WebAdviceCardRepository {
    if (singletonAdviceRepository == null) {
        console.log("🏗️ Creating SINGLETON WebAdviceCardRepository for Web")
        val database = WebDatabaseRepositoryFactory.getDatabaseAsync()
        val repository = WebAdviceCardRepository(database)

        // Seed default cards
        try {
            repository.seedDefaultCards()
            console.log("✅ Web AdviceCardRepository: Default cards seeded")
        } catch (e: Exception) {
            console.warn("⚠️ Web AdviceCardRepository: Error seeding cards: ${e.message}")
        }

        singletonAdviceRepository = repository
    } else {
        console.log("♻️ Reusing existing SINGLETON WebAdviceCardRepository")
    }
    return singletonAdviceRepository!!
}
